(() => {
  const mq=window.matchMedia('(max-width:1024px), (max-width:1366px) and (any-pointer:coarse)');
  const states=new Map();
  function createDesktop(section,form){
    const meta=form.querySelector('.product-meta');
    const title=meta?.querySelector('.product-meta__title');
    const vendor=meta?.querySelector('.product-meta__vendor');
    const sku=meta?.querySelector('.product-meta__sku');
    const price=form.querySelector('.product-form__info-list .price-list');
    const discount=meta?.querySelector('.product-label--on-sale');
    const origin=price?.closest('.product-form__info-item');
    const canadian=meta?.querySelector('.product-label--canadian');
    const image=section.querySelector('.product-gallery__carousel-wrapper');
    const quantity=form.querySelector('.product-form__info-item--quantity');
    const payment=form.querySelector('.product-form__payment-container');
    const terms=form.querySelector('shopify-payment-terms');
    const french=document.documentElement.lang.startsWith('fr');
    let data={};try{data=JSON.parse(section.querySelector('[data-product-json]')?.textContent||'{}');}catch{}
    const moves=[];
    let active=false,row,details,discountHTML,originalOptionName,summaryOptionName;
    function move(el,parent,before=null){
      if(!el||!parent)return;
      const marker=document.createComment('dl-desktop-original');
      el.before(marker);moves.push([el,marker]);parent.insertBefore(el,before);
    }
    function sync(){
      if(!active)return;
      const selected=originalOptionName?.querySelector('.product-form__selected-value')?.textContent;
      const summaryValue=summaryOptionName?.querySelector('.product-form__selected-value');
      if(summaryValue&&summaryValue.textContent!==selected)summaryValue.textContent=selected||'';
      const id=form.querySelector('[name="id"]')?.value;
      const variant=data.product?.variants?.find(v=>String(v.id)===String(id));
      const button=payment?.querySelector('.product-form__add-button');
      if(button){
        const span=button.querySelector('.dl-desktop-button-price');
        const current=price?.querySelector('.price:not(.price--compare)');
        const amount=current?Array.from(current.childNodes).filter(n=>n.nodeType===3).map(n=>n.textContent).join('').trim():'';
        if(button.dataset.action==='add-to-cart'&&!button.disabled&&amount){
          if(span){if(span.textContent!==' · '+amount)span.textContent=' · '+amount;}
          else{const node=document.createElement('span');node.className='dl-desktop-button-price';node.textContent=' · '+amount;button.append(node);}
        }else span?.remove();
      }
      if(discount&&variant){
        const saving=(variant.compare_at_price||0)-variant.price;
        const money=new Intl.NumberFormat(french?'fr-CA':'en-CA',{minimumFractionDigits:0,maximumFractionDigits:2}).format(saving/100)+' $';
        const label=(french?'Économisez ':'Save ')+money;
        if(saving>0&&discount.textContent!==label)discount.textContent=label;
        discount.style.display=saving>0?'':'none';
      }
    }
    function layout(enable){
      if(enable===active)return;
      if(enable&&meta&&title&&price){
        active=true;section.setAttribute('data-dl-desktop-pdp','');
        discountHTML=discount?.innerHTML;
        move(vendor,meta,title);
        if(canadian&&image){move(canadian,image,image.firstChild);canadian.classList.add('dl-desktop-canadian');}
        row=document.createElement('div');row.className='dl-desktop-price-row';title.after(row);
        move(price,row);move(discount,row);
        origin?.classList.add('dl-desktop-price-origin');
        details=document.createElement('div');details.className='dl-desktop-details';
        const option=Array.from(form.querySelectorAll('.product-form__option')).find(el=>el.hasAttribute('data-dl-color-option')||/^(fini|finish)\s*:/i.test(el.querySelector('.product-form__option-name')?.textContent?.trim()||''));
        originalOptionName=option?.querySelector('.product-form__option-name');
        if(originalOptionName){
          summaryOptionName=originalOptionName.cloneNode(true);summaryOptionName.removeAttribute('for');summaryOptionName.removeAttribute('id');
          details.append(summaryOptionName);originalOptionName.classList.add('dl-desktop-option-title');
        }
        row.after(details);move(sku,details);
        if(payment){payment.classList.add('dl-desktop-buy-row');move(quantity,payment,payment.firstChild);move(terms,payment);}
        sync();
      }else if(active){
        active=false;
        for(const [el,marker]of moves.splice(0))marker.replaceWith(el);
        if(discount&&discountHTML!==undefined)discount.innerHTML=discountHTML;
        row?.remove();details?.remove();origin?.classList.remove('dl-desktop-price-origin');
        originalOptionName?.classList.remove('dl-desktop-option-title');
        canadian?.classList.remove('dl-desktop-canadian');
        payment?.classList.remove('dl-desktop-buy-row');
        payment?.querySelector('.dl-desktop-button-price')?.remove();
        section.removeAttribute('data-dl-desktop-pdp');
      }
    }
    return {layout,sync};
  }

  function init(section){
    if(states.has(section))return;
    const form=section.querySelector('.product-form');
    if(!form)return;
    const gallery=section.querySelector('.product-gallery');
    const breadcrumb=section.querySelector('.breadcrumb');
    const galleryBlock=section.querySelector('.product-block-list__item--gallery');
    const labels=form.querySelector('.product-meta__label-list');
    const discount=labels?.querySelector('.product-label--on-sale');
    const price=form.querySelector('.product-form__info-list .price-list');
    const quantity=form.querySelector('.product-form__info-item--quantity');
    const terms=form.querySelector('shopify-payment-terms');
    const payment=form.querySelector('.product-form__payment-container');
    const meta=form.querySelector('.product-meta');
    const separator=form.querySelector('.card__separator');
    const desktop=createDesktop(section,form);
    const stock=form.querySelector('.dl-manufacturer-stock');
    let stockStates={};
    try{stockStates=JSON.parse(stock?.querySelector('[data-manufacturer-stock]')?.textContent||'{}');}catch{}
    let stockProduct={};
    try{stockProduct=JSON.parse(section.querySelector('[data-product-json]')?.textContent||'{}').product||{};}catch{}
    const stockMessages=Array.from(stock?.querySelectorAll('[data-stock-message]')||[]);
    const stockLowTitle=stock?.querySelector('[data-stock-message="low_stock"] [data-stock-title]');
    const stockLowPattern=stockLowTitle?.textContent.replace(/\d+/, '{count}');
    function syncStock(){
      if(!stock)return;
      const id=form.querySelector('[name="id"]')?.value;
      const entry=stockStates[id];
      const state=entry?.state||'unavailable';
      if(stock.dataset.stockState!==state)stock.dataset.stockState=state;
      stockMessages.forEach(message=>{
        const hidden=message.dataset.stockMessage!==state;
        if(message.hidden!==hidden)message.hidden=hidden;
      });
      if(state==='low_stock'&&stockLowTitle){
        const title=stockLowPattern.replace('{count}',String(entry.quantity));
        if(stockLowTitle.textContent!==title)stockLowTitle.textContent=title;
      }
      const variant=stockProduct.variants?.find(v=>String(v.id)===String(id));
      const blocked=state==='sold_out'||state==='unavailable'||variant?.available===false;
      const button=payment?.querySelector('.product-form__add-button');
      if(payment&&button){
        if(blocked){
          if(!payment.hasAttribute('data-dl-stock-blocked'))payment.setAttribute('data-dl-stock-blocked','');
          if(!button.disabled)button.disabled=true;
          if(button.dataset.action)delete button.dataset.action;
          if(button.textContent!==stock.dataset.soldLabel)button.textContent=stock.dataset.soldLabel;
        }else if(payment.hasAttribute('data-dl-stock-blocked')){
          payment.removeAttribute('data-dl-stock-blocked');
          button.disabled=false;button.dataset.action='add-to-cart';
          button.classList.remove('button--disabled');button.classList.add('button--primary');
          button.textContent=stock.dataset.addLabel;
        }
      }
    }
    form.addEventListener('change',()=>requestAnimationFrame(syncStock));
    form.addEventListener('submit',event=>{
      const state=stockStates[form.querySelector('[name="id"]')?.value]?.state;
      if(stock&&(state==='sold_out'||state===undefined)){event.preventDefault();event.stopImmediatePropagation();}
    },true);
    const moves=[];
    let counter;
    let priceRow;
    let arrows=[];
    const move=(el,parent,before=null)=>{
      if(!el||!parent)return;
      const marker=document.createComment('dl-original-position');
      el.before(marker); moves.push([el,marker]);parent.insertBefore(el,before);
    };
    function sync(){
      if(counter&&gallery){
        const thumbs=Array.from(gallery.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)'));
        let selected=thumbs.findIndex(t=>t.classList.contains('is-nav-selected'));
        const cell=gallery.querySelector('.product-gallery__carousel-item.is-selected');
        if(cell){const i=thumbs.findIndex(t=>t.dataset.mediaId===cell.dataset.mediaId);if(i>=0)selected=i;}
        const value=(thumbs.length?Math.max(0,selected)+1:0)+'/'+thumbs.length;
        if(counter.textContent!==value)counter.textContent=value;
        arrows.forEach(button=>{button.hidden=thumbs.length<2;});
        thumbs.forEach((t,i)=>{
          const current=i===Math.max(0,selected);
          if(t.getAttribute('aria-current')!==String(current))t.setAttribute('aria-current',String(current));
          t.setAttribute('aria-label',(document.documentElement.lang.startsWith('fr')?'Image ':'Image ')+(i+1)+' / '+thumbs.length);
        });
      }
      syncStock();
      desktop.sync();
      if(!mq.matches)return;
      const variantId=form.querySelector('[name="id"]')?.value;
      if(terms&&variantId&&terms.getAttribute('variant-id')!==String(variantId))terms.setAttribute('variant-id',variantId);
      const button=payment?.querySelector('.product-form__add-button');
      if(button){
        const span=button.querySelector('.dl-mobile-button-price');
        const currentPrice=price?.querySelector('.price:not(.price--compare)');
        const label=currentPrice?Array.from(currentPrice.childNodes).filter(n=>n.nodeType===3).map(n=>n.textContent).join('').trim():'';
        const available=button.dataset.action==='add-to-cart'&&!button.disabled;
        if(available&&label){
          if(!span){const el=document.createElement('span');el.className='dl-mobile-button-price';el.textContent=' · '+label;button.append(el);}
          else if(span.textContent!==' · '+label)span.textContent=' · '+label;
        }else span?.remove();
      }
    }
    function layout(){
      if(mq.matches){
        desktop.layout(false);
        if(!section.hasAttribute('data-dl-mobile-pdp')){
          section.setAttribute('data-dl-mobile-pdp','');
          if(breadcrumb&&galleryBlock){move(breadcrumb,galleryBlock,galleryBlock.firstChild);breadcrumb.classList.add('dl-mobile-breadcrumb');}
          if(labels&&gallery){move(labels,gallery,gallery.firstChild);labels.classList.add('dl-gallery-badges');}
          if(price&&meta){
            price.closest('.product-form__info-item').classList.add('dl-price-origin');
            move(price,form,separator||meta.nextSibling);price.classList.add('dl-top-price');
          }
          if(discount&&price){priceRow=document.createElement('div');priceRow.className='dl-price-row';price.before(priceRow);priceRow.append(price);move(discount,priceRow);discount.classList.add('dl-price-discount');}
          if(terms&&payment){move(terms,payment);terms.classList.add('dl-top-payment-terms');}
          if(quantity&&payment){payment.classList.add('dl-buy-row');move(quantity,payment,payment.firstChild);}
          if(gallery){
            const wrapper=gallery.querySelector('.product-gallery__carousel-wrapper');
            if(wrapper){
              [-1,1].forEach(direction=>{
                const button=document.createElement('button');
                button.type='button';
                button.className='dl-gallery-arrow dl-gallery-arrow--'+(direction<0?'previous':'next');
                const french=document.documentElement.lang.startsWith('fr');
                button.setAttribute('aria-label',direction<0?(french?'Image précédente':'Previous image'):(french?'Image suivante':'Next image'));
                button.innerHTML='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true" focusable="false"><path d="'+(direction<0?'M14 6l-6 6 6 6':'M10 6l6 6-6 6')+'" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                button.addEventListener('click',event=>{
                  event.preventDefault();event.stopPropagation();
                  const thumbs=Array.from(gallery.querySelectorAll('.product-gallery__thumbnail:not(.is-filtered)'));
                  if(thumbs.length<2)return;
                  const selectedCell=gallery.querySelector('.product-gallery__carousel-item.is-selected');
                  let current=thumbs.findIndex(thumb=>thumb.dataset.mediaId===selectedCell?.dataset.mediaId);
                  if(current<0)current=thumbs.findIndex(thumb=>thumb.classList.contains('is-nav-selected'));
                  thumbs[(Math.max(0,current)+direction+thumbs.length)%thumbs.length].click();
                });
                wrapper.append(button);arrows.push(button);
              });
            }
            const scroller=gallery.querySelector(':scope > .scroller');
            if(scroller){counter=document.createElement('span');counter.className='dl-gallery-counter';counter.setAttribute('aria-live','polite');scroller.append(counter);}
          }
        }
        sync();
      }else{
        for(const [el,marker] of moves.splice(0)){marker.replaceWith(el);}
        section.removeAttribute('data-dl-mobile-pdp');
        breadcrumb?.classList.remove('dl-mobile-breadcrumb');
        discount?.classList.remove('dl-price-discount');
        terms?.classList.remove('dl-top-payment-terms');
        priceRow?.remove();priceRow=null;
        labels?.classList.remove('dl-gallery-badges');price?.classList.remove('dl-top-price');
        form.querySelector('.dl-price-origin')?.classList.remove('dl-price-origin');
        payment?.classList.remove('dl-buy-row');payment?.querySelector('.dl-mobile-button-price')?.remove();
        counter?.remove();counter=null;
        arrows.forEach(button=>button.remove());arrows=[];
        desktop.layout(true);
      }
    }
    const observer=new MutationObserver(()=>{observer.disconnect();sync();observer.observe(section,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','disabled']});});
    states.set(section,{layout,observer});
    layout();
    document.getElementById('dl-pdp-pending-'+section.dataset.sectionId)?.remove();
    observer.observe(section,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','disabled']});
  }
  const scan=()=>document.querySelectorAll('[data-section-type="product"]').forEach(init);
  mq.addEventListener('change',()=>states.forEach(s=>s.layout()));
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',e=>{const section=e.target.querySelector('[data-section-type="product"]');const s=states.get(section);s?.observer.disconnect();states.delete(section);});
  // The section markup is complete here; do not wait for the rest of the page.
  scan();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);
})();